import React, { useState } from 'react';
import ReactTable from 'react-table';
import matchSorter from 'match-sorter';
import TablePagination from 'components/ui/TablePagination';
import GmailAccountDetails from './GmailAccountDetails';
import ESPRenderer from '../../../components/blocks/ESPRenderer';

const ViewRow = props => {
  return <a onClick={props.handleSelectItem(props.accountId)}>{props.value}</a>;
};

function GmailAccountListTable(props) {
  const { data, filtered, limitData } = props;

  const { limit, accounts = [] } = limitData;

  const [selectedId, setSelectedId] = useState(null);

  const handleSelectItem = id => () => setSelectedId(id);
  const handleClose = handleSelectItem(null);

  const selectedData = selectedId ? data.find(v => v.id === selectedId) : null;

  return (
    <>
      <ReactTable
        PaginationComponent={TablePagination}
        className="-highlight"
        columns={[
          {
            Header: 'Name',
            id: 'display_name',
            accessor: d => (
              <ViewRow
                accountId={d.id}
                handleSelectItem={handleSelectItem}
                value={d.display_name}
              />
            ),
            minWidth: 150,
          },
          {
            Header: 'Email',
            id: 'email',
            accessor: 'email',
            minWidth: 250,
          },
          {
            Header: 'Service',
            id: 'esp',
            minWidth: 150,
            accessor: d => {
              return <ESPRenderer esp={d.esp} />;
            },
          },
          {
            Header: 'Quota Today',
            id: 'quota_today',
            accessor: d => {
              const quotaToday = accounts.find(v => v.email === d.email);
              return `${quotaToday?.quota || 0} / ${limit}`;
            },
            minWidth: 150,
            style: { textAlign: 'center' },
          },
          {
            Header: 'Pending Emails',
            id: 'num_pending',
            accessor: d => (d.num_pending ? d.num_pending : 'None'),
            width: 80,
            sortMethod: (a, b) => {
              const aa = typeof a === 'number' ? a : 0;
              const bb = typeof b === 'number' ? b : 0;
              if (aa > bb) return -1;
              if (aa < bb) return 1;
              return 0;
            },
            style: { textAlign: 'center' },
            headerStyle: { display: 'grid', placeItems: 'center' },
          },
          {
            Header: 'Active',
            id: 'active',
            accessor: d =>
              d.suspended_at || d.revoked || d.as_reply_to ? 'No' : 'Yes',
            width: 75,
            style: { textAlign: 'center' },
            headerStyle: { display: 'grid', placeItems: 'center' },
          },
          {
            Header: 'Revoked',
            id: 'revoked',
            accessor: d => (d.revoked ? 'Yes' : 'No'),
            width: 85,
            style: { textAlign: 'center' },
            headerStyle: { display: 'grid', placeItems: 'center' },
          },
          {
            Header: 'Suspended',
            id: 'suspended',
            accessor: d => (d.suspended_at ? 'Yes' : 'No'),
            width: 100,
            style: { textAlign: 'center' },
            headerStyle: { display: 'grid', placeItems: 'center' },
          },
          {
            Header: 'Reply only',
            id: 'reply_only',
            accessor: d => (d.as_reply_to ? 'Yes' : 'No'),
            width: 95,
            style: { textAlign: 'center' },
            headerStyle: { display: 'grid', placeItems: 'center' },
          },
          {
            Header: 'Authorized on App',
            id: 'authorized_app',
            accessor: d => d.authorized_app?.toUpperCase(),
            minWidth: 200,
          },
          {
            Header: 'Last revoked',
            id: 'last_revoked_on',
            accessor: d => d.last_revoked_on || 'N/A',
            width: 160,
            style: { textAlign: 'center' },
            headerStyle: { display: 'grid', placeItems: 'center' },
          },
          {
            Header: 'Last authorized',
            id: 'last_authorized_on',
            accessor: d => d.last_authorized_on || 'N/A',
            width: 160,
            style: { textAlign: 'center' },
            headerStyle: { display: 'grid', placeItems: 'center' },
          },
          {
            Header: 'Last suspended',
            id: 'suspended_at',
            accessor: d => d.suspended_at || 'N/A',
            width: 160,
            style: { textAlign: 'center' },
            headerStyle: { display: 'grid', placeItems: 'center' },
          },
          {
            Header: 'Last sent template',
            id: 'last_template_id',
            accessor: d => d.last_template_id || 'N/A',
            sortMethod: (a, b) => {
              const aa = typeof a === 'number' ? a : 0;
              const bb = typeof b === 'number' ? b : 0;
              if (aa > bb) return -1;
              if (aa < bb) return 1;
              return 0;
            },
            width: 160,
            style: { textAlign: 'center' },
            headerStyle: { display: 'grid', placeItems: 'center' },
          },
          {
            Header: 'Total Sent (Today)',
            id: 'today_sent_count',
            accessor: d => d.today_sent_count || 0,
            width: 160,
            style: { textAlign: 'right' },
            headerStyle: { display: 'grid', placeItems: 'center' },
          },
          {
            Header: 'Total Sent (Lifetime)',
            id: 'total_sent_count',
            accessor: d => d.total_sent_count || 0,
            width: 160,
            style: { textAlign: 'right' },
            headerStyle: { display: 'grid', placeItems: 'center' },
          },
          {
            Header: '',
            id: 'all',
            width: 0,
            resizable: false,
            sortable: false,
            show: false,
            Filter: () => {},
            getProps: () => {},
            filterMethod: (filter, rows) => {
              const result = matchSorter(rows, filter.value, {
                keys: ['name', 'email'],
                threshold: matchSorter.rankings.CONTAINS,
              });
              return result;
            },
            filterAll: true,
          },
        ]}
        data={data}
        defaultPageSize={15}
        filtered={filtered}
        firstText={<i className="material-icons">first_page</i>}
        lastText={<i className="material-icons">last_page</i>}
        minRows={0}
        nextText={<i className="material-icons">chevron_right</i>}
        previousText={<i className="material-icons">chevron_left</i>}
        rowsSelectorText="Rows per page"
        showPageJump={false}
        showPaginationBottom
      />
      {selectedData && (
        <GmailAccountDetails
          data={selectedData}
          id={selectedId}
          onClose={handleClose}
        />
      )}
    </>
  );
}

export default GmailAccountListTable;
